import React from "react";

const StatClan = () => {
  return (
    <div className="bg-slate-800 p-4 rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4 text-white">Clan Info</h2>
      {/* Add additional clan information here */}
      will be added soon ...
    </div>
  );
};

export default StatClan;
